import { render, staticRenderFns } from "./ReferralsChart.vue?vue&type=template&id=332fdd16&scoped=true"
import script from "./ReferralsChart.vue?vue&type=script&lang=js"
export * from "./ReferralsChart.vue?vue&type=script&lang=js"
import style0 from "./ReferralsChart.vue?vue&type=style&index=0&id=332fdd16&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332fdd16",
  null
  
)

export default component.exports